import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withCtx as _withCtx, resolveDirective as _resolveDirective, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "Referral_Source",
  class: "row p-4 pb-0 g-0"
}
const _hoisted_2 = { class: "col-12 col-lg-6 pe-4" }
const _hoisted_3 = { class: "form-group col-12" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "referral-types" }, [
  /*#__PURE__*/_createTextVNode(" Referral Type "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: null }, "--Select Referral Type--", -1 /* HOISTED */)
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_8 = { class: "form-group col-12" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "referral-source-physician" }, [
  /*#__PURE__*/_createTextVNode(" Referral Source "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "referral-source-family" }, [
  /*#__PURE__*/_createTextVNode(" Referral Source "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = {
  key: 2,
  class: "field-invalid"
}
const _hoisted_15 = {
  key: 0,
  class: "form-group col-12"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "referral-details" }, [
  /*#__PURE__*/_createTextVNode(" Referral Details "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_17 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_18 = { class: "col-12 col-lg-6" }
const _hoisted_19 = { class: "form-group col-12" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "referral-date" }, [
  /*#__PURE__*/_createTextVNode(" Referral Date "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_21 = { class: "input-group date datepickerInput" }
const _hoisted_22 = ["value"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_24 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_25 = { class: "form-group col-12" }
const _hoisted_26 = { for: "start-of-care-date" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Requested Start of Care Date ")
const _hoisted_28 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_29 = { class: "input-group date datepickerInput" }
const _hoisted_30 = ["value"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_32 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_33 = {
  key: 0,
  class: "form-group col-12"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { for: "admission-source" }, [
  /*#__PURE__*/_createTextVNode(" Admission Source "),
  /*#__PURE__*/_createElementVNode("a", {
    tabindex: "0",
    href: "javascript:void(0);",
    role: "button"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-primary font-size-xs" })
  ])
], -1 /* HOISTED */)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("option", { value: null }, "--Select Admission Source--", -1 /* HOISTED */)
const _hoisted_36 = ["value"]
const _hoisted_37 = {
  key: 1,
  class: "form-group col-12"
}
const _hoisted_38 = { for: "admission-type" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Admission Type ")
const _hoisted_40 = {
  tabindex: "0",
  href: "javascript:void(0);",
  role: "button"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-primary font-size-xs" }, null, -1 /* HOISTED */)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("option", { value: null }, "--Select Admission Type--", -1 /* HOISTED */)
const _hoisted_44 = ["value"]
const _hoisted_45 = { class: "form-group col-12" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { for: "marketer" }, " Marketer ", -1 /* HOISTED */)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("option", { value: null }, "--Select User--", -1 /* HOISTED */)
const _hoisted_48 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_custom_popover = _resolveDirective("custom-popover")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Referral Source",
    "full-height": false,
    "application-id": _ctx.referral.application
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _withDirectives(_createElementVNode("select", {
              class: _normalizeClass(["form-select", `${!_ctx.v$.referral.referralType.$error ? '' : 'field-invalid'}`]),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.referral.referralType) = $event)),
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.refTypeChanged(_ctx.referral.referralType))),
              onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.referralType.$touch && _ctx.v$.referral.referralType.$touch(...args)))
            }, [
              _hoisted_5,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumToMap(_ctx.referralTypesEnum), ([key, value]) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: value.value,
                  key: key
                }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_6))
              }), 128 /* KEYED_FRAGMENT */))
            ], 34 /* CLASS, HYDRATE_EVENTS */), [
              [_vModelSelect, _ctx.referral.referralType]
            ]),
            (_ctx.v$.referral.referralType.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Referral Type is required."))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_ctx.showRefSourceTypeahead)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_component_TypeaheadInput, {
                    getData: _ctx.getList,
                    value: _ctx.referralSourceTypeahead,
                    onValueChanged: _ctx.changeTeamMember,
                    placeholder: _ctx.referralSourcePlaceholder,
                    onBlurredInput: _ctx.v$.referral.referralSource.$touch,
                    class: _normalizeClass(`${!_ctx.v$.referral.referralSource?.$error ? '' : 'field-invalid'}`)
                  }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "placeholder", "onBlurredInput", "class"])
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.showReferralSource)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _hoisted_12,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["form-control", `${!_ctx.v$.referral.referralSource.$error ? '' : 'field-invalid'}`]),
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.referral.referralSource) = $event)),
                    placeholder: _ctx.referralSourcePlaceholder,
                    onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.referralSource.$touch && _ctx.v$.referral.referralSource.$touch(...args)))
                  }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_13), [
                    [_vModelText, _ctx.referral.referralSource]
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            (
                                (_ctx.referralSourceValidation && _ctx.referral.referralSource == null) ||
                                _ctx.v$.referral.referralSource?.$error
                            )
              ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Referral Source is required."))
              : _createCommentVNode("v-if", true)
          ]),
          (_ctx.showReferralDetails)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _hoisted_16,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: _normalizeClass(["form-control", `${!_ctx.v$.referral.referralDetails.$error ? '' : 'field-invalid'}`]),
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.referral.referralDetails) = $event)),
                  placeholder: "Enter caller/referral details",
                  onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.referralDetails.$touch && _ctx.v$.referral.referralDetails.$touch(...args)))
                }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                  [_vModelText, _ctx.referral.referralDetails]
                ]),
                (
                                (_ctx.referralDetailsValidation && _ctx.referral.referralDetails == null) ||
                                _ctx.v$.referral.referralDetails.$error
                            )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Referral Details are required."))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode(_component_DatePicker, { getDate: _ctx.changeDate }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("input", {
                    placeholder: "MM/DD/YYYY",
                    type: "text",
                    class: _normalizeClass(["form-control", `${!_ctx.v$.referral.referralDate.$error ? '' : 'field-invalid'}`]),
                    name: "referralDate",
                    onBlur: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.referralDate.$touch && _ctx.v$.referral.referralDate.$touch(...args))),
                    value: _ctx.formatDateInput(_ctx.referral.referralDate),
                    onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args)))
                  }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_22),
                  _hoisted_23
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["getDate"]),
            (_ctx.v$.referral.referralDate.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Referral Date is required."))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("label", _hoisted_26, [
              _hoisted_27,
              (!_ctx.referral.isNonMedical)
                ? (_openBlock(), _createElementBlock("span", _hoisted_28, "*"))
                : _createCommentVNode("v-if", true)
            ]),
            _createVNode(_component_DatePicker, { getDate: _ctx.changeDate }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("input", {
                    placeholder: "MM/DD/YYYY",
                    name: "referralSOCDate",
                    type: "text",
                    class: _normalizeClass(["form-control", `${!_ctx.v$.referral.requestedStartOfCareDate.$error ? '' : 'field-invalid'}`]),
                    onBlur: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.requestedStartOfCareDate.$touch && _ctx.v$.referral.requestedStartOfCareDate.$touch(...args))),
                    value: _ctx.formatDateInput(_ctx.referral.requestedStartOfCareDate),
                    onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args)))
                  }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_30),
                  _hoisted_31
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["getDate"]),
            (_ctx.v$.referral.requestedStartOfCareDate.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.v$.referral.requestedStartOfCareDate.$errors[0].$message), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]),
          (!_ctx.referral.isNonMedical)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _hoisted_34,
                _withDirectives(_createElementVNode("select", {
                  class: "form-select",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.referral.admissionSource) = $event))
                }, [
                  _hoisted_35,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumToMap(_ctx.admissionSourcesEnum), ([key, value]) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: value.value,
                      key: key
                    }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_36))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 512 /* NEED_PATCH */), [
                  [_vModelSelect, _ctx.referral.admissionSource]
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (!_ctx.referral.isNonMedical)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _createElementVNode("label", _hoisted_38, [
                  _hoisted_39,
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_40, _hoisted_42)), [
                    [_directive_custom_popover, {
                                    content: _ctx.notSelectedTooltip,
                                    className: 'w-25 fw-sm info-popup'
                                }]
                  ])
                ]),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.referral.admissionType) = $event))
                }, [
                  _hoisted_43,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumToMap(_ctx.admissionSourcesEnum), ([key, value]) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: value.value,
                      key: key
                    }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_44))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 512 /* NEED_PATCH */), [
                  [_vModelSelect, _ctx.referral.admissionType]
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_45, [
            _hoisted_46,
            _withDirectives(_createElementVNode("select", {
              class: "form-select",
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.referral.internalReferral) = $event))
            }, [
              _hoisted_47,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: user.value,
                  key: user
                }, _toDisplayString(user.name), 9 /* TEXT, PROPS */, _hoisted_48))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, _ctx.referral.internalReferral]
            ])
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}